import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {ApiResultVo} from '../../common/shared/api/nicolas/vo/ApiResultVo.interface';
import type {TicketListResultVo} from '../../common/shared/api/nicolas/vo/TicketListResultVo.interface';

/**
 * 이용권 목록 조회
 *
 * Origin: pageNicolasApi.getTicketList
 * API: GET /api/v1/ticket/list
 */
export async function getTicketList(
  {
    seriesId,
    includeBanner,
  }: {
    seriesId: number;
    includeBanner: boolean;
  },
  options?: FetcherOptions
): Promise<ApiResultVo & {result: TicketListResultVo}> {
  const response = await axiosBffFetch(
    '/api/gateway/api/v1/ticket/list',
    {
      method: 'GET',
      params: {
        series_id: seriesId,
        ...(includeBanner && {include_banner: includeBanner}),
      },
    },
    options
  );
  return response.data;
}
